import React from 'react';
const ImageElement = React.memo(({ className, src, width, height }) => {
    return (React.createElement("img", { className: className, src: src, width: width, height: height }));
});
export default ImageElement;
